export default __webpack_public_path__ + "static/media/tarry.2e674b24.png";